const DEFAULT_ENVIRONMENT = 'production';
export { DEFAULT_ENVIRONMENT };
